import { Button } from "@components";

export function EditMenuStep({ onChangeName, onEditAccounts, onDelete }) {
  return (
    <div className="p-5 space-y-3">
      <Button
        type="button"
        className="w-full rounded-lg justify-start"
        onClick={onChangeName}
      >
        Rename
      </Button>
      <Button
        type="button"
        className="w-full rounded-lg justify-start"
        onClick={onEditAccounts}
      >
        Add / Remove Accounts
      </Button>
      <Button
        type="button"
        className="w-full rounded-lg justify-start text-red-500"
        onClick={onDelete}
      >
        Delete Group
      </Button>
    </div>
  );
}
